<template>
    <div class="ticket-checker-entry">
        <div v-if="isShowingResult" class="ticket-checker-entry__result">
            <div class="ticket-checker-entry__result-ticket">
                <span>{{ userTicket }}: </span>
            </div>
            <div>
                <span class="h5">{{ wonPrize || noPrizeText }}</span>
            </div>
        </div>
        <template v-else>
            <div class="ticket-checker-entry__ticket">
                <input
                    name="ticket"
                    :value="userTicket"
                    :type="numericOnly ? 'number' : 'text'"
                    :pattern="numericOnly && '[0-9]*'"
                    autocomplete="off"
                    :maxlength="maxLength"
                    @input="updateUserTicket"
                />
            </div>
        </template>
    </div>
</template>

<script>
import './ticket-checker-entry.scss';

export default {
    name: 'TicketCheckerEntry',
    props: {
        drawing: {
            type: Object,
        },
        numericOnly: {
            type: Boolean,
            default: false,
        },
        maxLength: {
            type: Number,
            default: 11,
        },
        noPrizeText: {
            type: String,
            default: 'Helaas, geen prijs',
        },
    },
    data() {
        return {
            isShowingResult: false,
            selectedDrawingIndex: 0,
            userTicket: '',
            wonPrize: null,
        };
    },
    methods: {
        reset() {
            this.isShowingResult = false;
            this.selectedDrawingIndex = 0;
            this.userTicket = '';
            this.wonPrize = null;
        },
        checkTicket() {
            this.isShowingResult = true;
            const winningTicket = this.drawing.winningTickets.find(ticket => ticket.ticketCode === this.userTicket);
            if (winningTicket) {
                this.wonPrize = winningTicket.prizeReference;
                this.$emit('won', this.wonPrize);
            }
        },
        updateUserTicket(event) {
            const value = event.target.value;

            if (value.length <= this.maxLength) {
                this.userTicket = value;
            }

            this.$forceUpdate();
        },
    },
};
</script>
